import * as Yup from 'yup';

import product from './product';

const productFormSchema = Yup.object({
  product: product
});

export default productFormSchema;
export type ProductFormSchema = ReturnType<typeof productFormSchema.cast>;
